export const heroData = {
  title: "Experience Yokohama\nFrom the Sky",
  subtitle:
    "AIRDOA is a premium booking media for helicopter sightseeing tours in Yokohama. Perfect for anniversaries and dates, with easy guidance for first-time visitors. Breathtaking views that can't be seen from the ground.",
  ctaPrimary: { label: "View Yokohama Heli Cruise", href: "/yokohama" },
  ctaSecondary: { label: "View Pricing & Plans", href: "/pricing" },
  image:
    "https://readdy.ai/api/search-image?query=Aerial%20night%20view%20of%20Yokohama%20city%20skyline%20with%20Minato%20Mirai%20landmark%20tower%20and%20ferris%20wheel%20illuminated%2C%20helicopter%20perspective%2C%20dark%20navy%20blue%20sky%20with%20city%20lights%20reflecting%20on%20bay%20water%2C%20cinematic%20luxury%20atmosphere%2C%20no%20text%2C%20high%20detail%2C%208k%20quality&width=1920&height=800&seq=hero01&orientation=landscape",
};

export const yokohamaFeature = {
  label: "FEATURED AREA",
  title: "Yokohama Heli Cruise",
  subtitle:
    "A special experience viewing Yokohama's iconic night scenery not from the ground, but from the sky. Enjoy a panoramic view of Minato Mirai's skyscrapers, the Bay Bridge, and Red Brick Warehouse.",
  image:
    "https://readdy.ai/api/search-image?query=Helicopter%20flying%20over%20Yokohama%20bay%20bridge%20and%20Minato%20Mirai%20waterfront%20during%20golden%20hour%20sunset%2C%20aerial%20photography%20perspective%2C%20warm%20orange%20and%20deep%20navy%20sky%2C%20luxury%20travel%20experience%2C%20clean%20composition%2C%20no%20text%2C%20editorial%20photography%20style&width=1200&height=800&seq=yoko01&orientation=landscape",
  cta: { label: "View Yokohama Experience", href: "/yokohama" },
  stats: [
    { value: "~15 min", label: "Shortest Course" },
    { value: "2+ guests", label: "Capacity" },
    { value: "Night View", label: "Most Popular" },
  ],
};

export const aboutData = {
  label: "ABOUT AIRDOA",
  title: "What is AIRDOA?",
  description:
    "AIRDOA is a specialized web media platform for booking helicopter sightseeing tours. We aim to provide safe, high-quality booking experiences for special occasions — anniversary dates, proposals, sightseeing, and gifts. Yokohama from the sky delivers an emotion that the ground simply cannot.",
  points: [
    { icon: "ri-calendar-check-line", title: "Easy Booking Platform", desc: "Simple online consultations. Our dedicated staff will suggest the perfect plan for you." },
    { icon: "ri-shield-check-line", title: "Uncompromising Safety", desc: "We only partner with MLIT-certified operators, rigorously verifying maintenance records and pilot credentials." },
    { icon: "ri-vip-crown-line", title: "Perfect for Anniversaries", desc: "Ideal for proposals, birthdays, and wedding anniversaries. Gift wrapping and special arrangements available." },
  ],
};

export const strengthsData = {
  label: "WHY AIRDOA",
  title: "Why Choose AIRDOA",
  items: [
    {
      icon: "ri-shield-check-line",
      title: "Safe & Reliable",
      desc: "We partner exclusively with MLIT-certified operators, rigorously verifying maintenance records and pilot credentials.",
    },
    {
      icon: "ri-heart-line",
      title: "Perfect for Anniversaries & Dates",
      desc: "Ideal for proposals, birthdays, and wedding anniversaries. We create a special moment in the sky.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Easy to Book",
      desc: "Online inquiries available 24/7. Our dedicated staff will respond within the next business day.",
    },
    {
      icon: "ri-sparkling-line",
      title: "A Truly Special Experience",
      desc: "Breathtaking panoramic views that cannot be seen from the ground — an extraordinary memory in the making.",
    },
    {
      icon: "ri-gift-line",
      title: "The Perfect Gift",
      desc: "A wonderful surprise for someone special. Gift tickets come beautifully wrapped and delivered.",
    },
    {
      icon: "ri-customer-service-line",
      title: "Worry-Free for First-Timers",
      desc: "We provide detailed guidance before your flight — covering attire, what to bring, and the day-of schedule.",
    },
  ],
};

export const scenesData = {
  label: "SCENES",
  title: "Perfect for These Occasions",
  items: [
    {
      tag: "DATE",
      title: "Date",
      desc: "Step away from the everyday and share a truly private moment together. Gazing at the night view from above creates a memory you will never forget.",
      image:
        "https://readdy.ai/api/search-image?query=Romantic%20couple%20silhouette%20inside%20helicopter%20cabin%20looking%20at%20beautiful%20night%20cityscape%20through%20window%2C%20soft%20warm%20interior%20lighting%2C%20luxury%20helicopter%20experience%2C%20dark%20navy%20sky%20outside%20with%20twinkling%20city%20lights%2C%20intimate%20atmosphere%2C%20editorial%20style%2C%20no%20text%20visible&width=800&height=600&seq=scene01&orientation=landscape",
    },
    {
      tag: "ANNIVERSARY",
      title: "Anniversary",
      desc: "Surprise your partner on a birthday or wedding anniversary with a helicopter experience. Views from the sky add brilliance to a very special day.",
      image:
        "https://readdy.ai/api/search-image?query=Elegant%20champagne%20glasses%20clinking%20inside%20luxury%20helicopter%20cabin%20with%20panoramic%20city%20night%20view%20through%20window%2C%20warm%20golden%20interior%20lighting%2C%20dark%20navy%20sky%20with%20sparkling%20city%20lights%2C%20special%20celebration%20atmosphere%2C%20high-end%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=scene02&orientation=landscape",
    },
    {
      tag: "PROPOSE",
      title: "Proposal",
      desc: "The ultimate backdrop for the most important question. Words spoken in front of the night view become a treasure that lasts a lifetime.",
      image:
        "https://readdy.ai/api/search-image?query=Man%20proposing%20to%20woman%20with%20ring%20box%20inside%20helicopter%20at%20night%20with%20stunning%20city%20skyline%20visible%20through%20panoramic%20window%2C%20romantic%20golden%20lighting%20inside%20cabin%2C%20dark%20navy%20sky%2C%20luxury%20special%20moment%2C%20editorial%20photography%20style%2C%20no%20text&width=800&height=600&seq=scene03&orientation=landscape",
    },
    {
      tag: "SIGHTSEEING",
      title: "Sightseeing",
      desc: "The highlight of any Yokohama visit. Take in the Red Brick Warehouse, Bay Bridge, and Minato Mirai all at once from above.",
      image:
        "https://readdy.ai/api/search-image?query=Aerial%20daytime%20view%20of%20Yokohama%20city%20from%20helicopter%20showing%20red%20brick%20warehouse%20district%2C%20bay%20bridge%2C%20and%20Minato%20Mirai%20skyline%2C%20clear%20blue%20sky%20with%20white%20clouds%2C%20bright%20natural%20lighting%2C%20travel%20sightseeing%20experience%2C%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=scene04&orientation=landscape",
    },
    {
      tag: "GIFT",
      title: "Gift",
      desc: "Give the gift of experience. A gift ticket is the most memorable present you can offer someone special.",
      image:
        "https://readdy.ai/api/search-image?query=Luxury%20gift%20box%20with%20gold%20ribbon%20placed%20on%20dark%20navy%20surface%20with%20soft%20ambient%20lighting%2C%20elegant%20minimalist%20product%20photography%2C%20champagne%20gold%20accent%20colors%2C%20premium%20gift%20experience%20atmosphere%2C%20no%20text%2C%20high-end%20editorial%20style&width=800&height=600&seq=scene05&orientation=landscape",
    },
  ],
};

export const plansData = {
  label: "PLANS",
  title: "Recommended Yokohama Plans",
  subtitle: "Choose the perfect course to match your purpose and budget",
  plans: [
    {
      name: "Night View Short",
      duration: "~15 min",
      price: "Please inquire",
      description: "A quick course to enjoy Minato Mirai's night view — easy and accessible",
      features: ["Minato Mirai Illumination", "Bay Bridge", "2 guests"],
      popular: false,
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20cabin%20interior%20with%20leather%20seats%20and%20panoramic%20window%20showing%20city%20view%20at%20dusk%2C%20warm%20golden%20interior%20lighting%2C%20luxury%20aviation%20experience%2C%20dark%20navy%20sky%20outside%2C%20comfortable%20and%20elegant%20atmosphere%2C%20no%20text&width=600&height=400&seq=plan01&orientation=landscape",
    },
    {
      name: "Night View Standard",
      duration: "~25 min",
      price: "Please inquire",
      description: "The most popular course, covering Yokohama's iconic landmarks at a relaxed pace",
      features: ["Minato Mirai Illumination", "Bay Bridge", "Red Brick Warehouse", "Yamashita Park", "2–3 guests"],
      popular: true,
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20night%20tour%20with%20sparkling%20city%20lights%20visible%20through%20window%2C%20dark%20navy%20sky%2C%20romantic%20atmosphere%2C%20luxury%20experience%2C%20editorial%20aviation%20photography%2C%20no%20text&width=600&height=400&seq=plan02&orientation=landscape",
    },
    {
      name: "Sunset + Night View",
      duration: "~30 min",
      price: "Please inquire",
      description: "A special course where you experience from the sky the moment the sunset gives way to the night skyline",
      features: ["Bay Bridge at Sunset", "Transition to Night View", "Mt. Fuji view (clear weather)", "2–3 guests"],
      popular: false,
      image:
        "https://readdy.ai/api/search-image?query=Helicopter%20flying%20over%20coastal%20city%20during%20dramatic%20sunset%20with%20orange%20and%20deep%20navy%20gradient%20sky%2C%20bay%20water%20reflecting%20sunset%20colors%2C%20luxury%20aerial%20photography%2C%20editorial%20style%2C%20no%20text&width=600&height=400&seq=plan03&orientation=landscape",
    },
  ],
};

export const stepsData = {
  label: "FIRST TIME",
  title: "For First-Time Visitors",
  subtitle: "Even on your first helicopter tour, you can enjoy it with complete peace of mind. Our dedicated staff will support you every step of the way.",
  steps: [
    {
      num: "01",
      title: "Easy Online Inquiry",
      desc: "Simply enter your preferred date, time, and number of guests. Our dedicated staff will suggest the best plan.",
      icon: "ri-computer-line",
    },
    {
      num: "02",
      title: "Pre-Departure Preparation",
      desc: "We provide guidance on attire, what to bring, and the day-of schedule. Feel free to ask us anything at any time.",
      icon: "ri-suitcase-line",
    },
    {
      num: "03",
      title: "Your Special Experience",
      desc: "After check-in at the helipad, you will take off with the pilot — and breathtaking scenery unfolds before you.",
      icon: "ri-flight-takeoff-line",
    },
  ],
  cta: { label: "First-Time Visitor Guide", href: "/first-time" },
};

export const safetyData = {
  label: "SAFETY",
  title: "Safety-First Operations",
  subtitle: "We select operating partners under strict safety standards, putting our customers' safety first",
  items: [
    {
      icon: "ri-file-shield-line",
      title: "MLIT-Certified Operators",
      desc: "All partnered operators hold MLIT certification. We rigorously review maintenance systems and operations management.",
    },
    {
      icon: "ri-user-star-line",
      title: "Experienced Pilots",
      desc: "Our pilots hold the required qualifications and have accumulated extensive flight hours. They undergo regular training and skill assessments.",
    },
    {
      icon: "ri-cloud-line",
      title: "Strict Weather Monitoring",
      desc: "We carefully assess weather and wind conditions on the day. Flights are cancelled if safety cannot be guaranteed.",
    },
    {
      icon: "ri-first-aid-kit-line",
      title: "Thorough Maintenance",
      desc: "Aircraft undergo regular inspections and maintenance. Only aircraft with valid airworthiness certificates are operated.",
    },
  ],
};

export const faqPreviewData = {
  label: "FAQ",
  title: "Frequently Asked Questions",
  items: [
    {
      q: "Is it okay if it's my first time?",
      a: "Absolutely. The majority of our guests are first-timers. We will send detailed guidance in advance, and our staff will take good care of you on the day.",
    },
    {
      q: "Are there any dress code requirements?",
      a: "Skirts and heels are fine, but since the helipad is outdoors, we recommend stable footwear. Please dress appropriately for the season.",
    },
    {
      q: "What happens if it rains or there are strong winds?",
      a: "Safety is our top priority. Flights may be cancelled on the day due to weather at the operator's discretion. In that case, we will offer rescheduling or a full refund.",
    },
    {
      q: "Can I purchase this as a gift?",
      a: "Yes, gift tickets are available. You can give someone special a truly unique experience. Gift wrapping is also available.",
    },
  ],
  cta: { label: "View More Questions", href: "/faq" },
};

export const accessData = {
  label: "ACCESS",
  title: "Getting to the Helipad",
  description:
    "The Yokohama helipad is conveniently located near the Minato Mirai area, easily accessible by train, car, or taxi.",
  image:
    "https://readdy.ai/api/search-image?query=Modern%20helipad%20facility%20entrance%20with%20clean%20architectural%20design%2C%20warm%20sunset%20lighting%2C%20luxury%20transportation%20hub%2C%20dark%20navy%20sky%20gradient%2C%20professional%20and%20welcoming%20atmosphere%2C%20editorial%20photography%2C%20no%20text&width=800&height=500&seq=access01&orientation=landscape",
  cta: { label: "View Access Details", href: "/access" },
};

export const giftData = {
  label: "GIFT",
  title: "A Sky Gift for Someone Special",
  description:
    "Experience is the greatest gift. Why not give a helicopter sightseeing gift ticket for a birthday or celebration? Beautifully wrapped, it creates a surprise that will be remembered forever.",
  cta: { label: "Purchase Gift Ticket", href: "/gift" },
  features: ["Dedicated gift wrapping", "With expiry date", "Message card available", "Booking assistance service"],
};

export const columnsData = {
  label: "COLUMN",
  title: "Latest Articles",
  subtitle: "Tips on Yokohama dates, helicopter tours, and gift ideas",
  items: [
    {
      title: "5 Tips for a Perfect Yokohama Helicopter Date",
      category: "Date & Anniversary",
      date: "2025.04.15",
      image:
        "https://readdy.ai/api/search-image?query=Close%20up%20of%20elegant%20watch%20and%20small%20gift%20box%20on%20dark%20marble%20surface%20with%20soft%20warm%20lighting%2C%20luxury%20lifestyle%20editorial%20photography%2C%20champagne%20gold%20tones%2C%20minimalist%20composition%2C%20no%20text&width=600&height=400&seq=col01&orientation=landscape",
      slug: "yokohama-heli-date-tips",
    },
    {
      title: "What to Wear & Bring: A Complete Guide to Your Helicopter Tour",
      category: "First-Time Visitors",
      date: "2025.04.10",
      image:
        "https://readdy.ai/api/search-image?query=Elegant%20navy%20and%20gold%20evening%20dress%20accessories%20on%20minimal%20white%20surface%2C%20luxury%20fashion%20editorial%20photography%2C%20soft%20natural%20lighting%2C%20minimalist%20composition%2C%20no%20text&width=600&height=400&seq=col02&orientation=landscape",
      slug: "heli-what-to-bring",
    },
    {
      title: "Night View vs Sunset vs Daytime — Which Time Slot is Best?",
      category: "Experience Guide",
      date: "2025.04.05",
      image:
        "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20coastal%20Japanese%20city%20at%20sunset%20transitioning%20to%20night%2C%20split%20time%20comparison%20with%20warm%20orange%20and%20deep%20navy%20blue%20sky%20gradient%2C%20editorial%20photography%20style%2C%20no%20text&width=600&height=400&seq=col03&orientation=landscape",
      slug: "best-time-for-heli-tour",
    },
  ],
};

export const reviewsData = {
  label: "VOICE",
  title: "Customer Reviews",
  subtitle: "Testimonials from guests who have experienced our tours",
  items: [
    {
      name: "K.Y.",
      age: "30s · Couple",
      comment:
        "We used AIRDOA for our wedding anniversary. The moment we saw Minato Mirai from the sky, we were speechless with emotion. It became a memory we will treasure for the rest of our lives.",
      rating: 5,
      scene: "Anniversary",
    },
    {
      name: "M.S.",
      age: "20s · Couple",
      comment:
        "It was my first time in a helicopter, but the staff guided us so carefully that I had no anxiety at all. It was the perfect date experience.",
      rating: 5,
      scene: "Date",
    },
    {
      name: "T.A.",
      age: "40s · Couple",
      comment:
        "I gave a gift ticket as a birthday surprise for my wife. The packaging was beautiful and she was absolutely delighted. The experience itself was incredible too.",
      rating: 5,
      scene: "Gift",
    },
  ],
};

export const areasData = {
  label: "AREAS",
  title: "Future Expansion Areas",
  subtitle: "The following areas are currently in preparation. Bookings will open soon.",
  active: [
    {
      name: "Yokohama",
      status: "Now Available",
      image:
        "https://readdy.ai/api/search-image?query=Yokohama%20Minato%20Mirai%20skyline%20at%20night%20with%20landmark%20tower%20and%20ferris%20wheel%2C%20deep%20navy%20sky%2C%20city%20lights%20reflecting%20on%20water%2C%20luxury%20travel%20destination%2C%20editorial%20photography%2C%20no%20text&width=600&height=400&seq=area01&orientation=landscape",
      href: "/yokohama",
    },
  ],
  preparing: [
    { name: "Hokkaido", status: "Coming Soon", image: "" },
    { name: "Aso", status: "Coming Soon", image: "" },
    { name: "Wakayama", status: "Coming Soon", image: "" },
    { name: "Okinawa", status: "Coming Soon", image: "" },
    { name: "Hawaii", status: "Coming Soon", image: "" },
    { name: "Nagoya", status: "Coming Soon", image: "" },
  ],
};

export const finalCTA = {
  title: "Experience Yokohama\nFrom the Sky",
  subtitle: "Views that can't be seen from the ground, shared with someone you love",
  ctas: [
    { label: "View Yokohama Heli Cruise", href: "/yokohama", type: "primary" },
    { label: "View Pricing & Plans", href: "/pricing", type: "secondary" },
    { label: "Inquire About Booking", href: "/contact", type: "ghost" },
  ],
};
